module.exports = __webpack_public_path__ + "static/media/eric-rebecca-akaka-falls@2x.21cbb376.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/eric-rebecca-akaka-falls@2x.jpg
// module id = 477
// module chunks = 0